const de = {
  // Header
  changePassword: 'Passwort ändern',
  logout: 'Abmelden',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',

  // Tabs
  tabData: 'Daten & Wettbewerbe',
  tabDashboard: 'Dashboard',
  tabAdmin: 'Administration',

  // Header-Buttons
  btnImages: 'Bilder',
  btnMaintenance: 'Datenpflege',

  // Import-Karten
  importSubmissions: 'Einreichungen importieren',
  importSubmissionsHint: 'Multi-Sheet Excel mit Acceptance/HM/Medal-Werten importieren',
  importResults: 'Bisherige Erfolge importieren',
  importResultsHint: 'Hier einmalig bereits vorhandene Erfolge aus Wettbewerben als Matrix-Excel importieren. Neue Ergebnisse bitte über "Ergebnis hinzufügen" erfassen.',
  importCompetitions: 'Wettbewerbsliste importieren',
  importCompetitionsHint: 'Offizielle Wettbewerbsliste importieren',
  deleteOwnData: 'Eigene Daten vorher löschen (Neuimport)',
  replaceSubmissions: 'Einreichungen ersetzen (Neuimport)',
  clearTable: 'Tabelle vorher leeren (Neuimport)',
  selectFile: 'Datei auswählen',
  importing: 'Importiert...',
  templateDownload: 'Vorlage',

  // Wettbewerbe suchen
  searchCompetitions: 'Wettbewerbe suchen',
  salonName: 'Salonname',
  fiapNumber: 'FIAP-Nummer',
  closingFromTo: 'Closing von – bis',
  search: 'Suchen',
  noResults: 'Keine Wettbewerbe gefunden.',
  results: 'Ergebnis',
  details: 'Details',
  less: 'weniger',

  // Ergebnis hinzufügen
  addResult: 'Ergebnis hinzufügen',
  selectImage: 'Bild wählen:',
  existingImage: '-- vorhandenes Bild --',
  newImage: 'Oder neues Bild:',
  newImageTitle: 'Neuer Bildtitel',
  selectFromFiap: 'Salon aus FIAP-Liste wählen:',
  salonNameLabel: 'Salonname:',
  fiapNumberLabel: 'FIAP Nummer:',
  country: 'Land:',
  searchCountry: 'Land suchen...',
  salonType: 'Salon-Typ:',
  resultLabel: 'Ergebnis:',
  save: 'Speichern',
  saving: 'Speichert...',
  exportCsv: 'Export CSV',

  // Dashboard
  distinction: 'Distinction:',
  overview: 'Übersicht',
  required: 'Erforderlich',
  progress: 'Fortschritt',
  acceptances: 'Annahmen',
  images: 'Bilder',
  countries: 'Länder',
  discarded: 'Verworfen',
  topImages: 'Top Bilder',
  overlimit: 'Overlimit',
  schedule: 'Einplanen',
  potentialImages: 'Bilder mit Potenzial',
  topFlops: 'Top Flops',
  noFlops: 'Keine Flops gefunden 🎉',
  successByCategory: 'Erfolge je Kategorie',
  countriesSuccess: 'Länder (Erfolge)',
  regionsSuccess: 'Regionen (Erfolg)',
  bestPerRegion: 'Bestes Bild je Region',
  noData: 'Keine Daten vorhanden',

  // Bildverwaltung
  imageManagement: 'Bildverwaltung',
  imageManagementHint: 'Lade für jedes Bild ein Thumbnail hoch (max. 2 MB, jpg / png / webp). Es wird automatisch dem jeweiligen Bildtitel zugeordnet.',
  upload: 'Hochladen',
  download: 'Download',
  uploading: '⏳',
  noImage: 'kein Bild',

  // Datenpflege
  dataMaintenance: 'Datenpflege',
  searchTitle: 'Bildtitel',
  searchCompetition: 'Wettbewerb',
  clearSearch: 'Suche leeren',
  warningDelete: '⚠️ Das Löschen von Datensätzen erfolgt auf eigene Gefahr und ist dauerhaft. Gelöschte Daten können nicht wiederhergestellt werden.',
  salon: 'Wettbewerb',
  result: 'Ergebnis',
  sessResultsLabel: 'Ergebnisse / Benutzer',
  delete: 'Löschen',
  confirmDelete: 'Ja, löschen',
  cancel: 'Abbrechen',

  // Administration
  adminImport: 'Wettbewerbsliste importieren',
  userManagement: 'Benutzerverwaltung',
  loginLog: 'Login-Protokoll',
  editUser: 'Bearbeiten',
  deactivate: 'Deaktivieren',
  activate: 'Aktivieren',
  deleteUser: 'Löschen',
  createUser: 'Neuen Benutzer anlegen',
  username: 'Benutzername',
  password: 'Passwort',
  role: 'Rolle',
  create: 'Anlegen',
  loggedIn: 'Angemeldet',
  loggedOut: 'Abgemeldet',
  duration: 'Dauer',
  ip: 'IP',
  active: 'aktiv',
  deactivated: 'deaktiviert',

  // Backend error messages
  errInvalidCredentials: 'Ungültige Anmeldedaten',
  errDeactivated: 'Dieses Konto ist deaktiviert',
  errExpired: 'Dieses Konto ist abgelaufen. Bitte einen Administrator kontaktieren.',
  errPasswordWrong: 'Aktuelles Passwort ist falsch',
  errPasswordTooShort: 'Neues Passwort muss mindestens 6 Zeichen haben',
  errUsernameTaken: 'Benutzername bereits vergeben',
  errInvalidRole: 'Ungültige Rolle',

  // Login
  loginTitle: 'Competa',
  loginBtn: 'Anmelden',
  loggingIn: 'Anmelden...',

  // Passwort ändern
  changePwTitle: 'Passwort ändern',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort',
  confirmPassword: 'Neues Passwort bestätigen',
  changePwBtn: 'Passwort ändern',
  // Datenpflege Tabelle
  imageTitle: 'Bildtitel',
  competition: 'Wettbewerb',
  land: 'Land',
  fiapNr: 'FIAP-Nr.',
  clearSearch: 'Suche leeren',
  resultsFound: 'Ergebnisse gefunden',
  sessResultsLabel: 'Ergebnisse / Benutzer',
  delete: 'Löschen',
  newPasswordHint: 'Neues Passwort (leer = unverändert)',

  // Expiry warning
  expiryWarningTitle: 'Ihr Abo läuft in {days} Tag{s} ab.',
  expiryWarningBody: 'Bitte denken Sie daran, Ihr Abo zu verlängern, um Competa nach dem {date} weiter nutzen zu können.',
  expiryWarningContact: 'Wenden Sie sich zum Verlängern Ihres Abos an',
  expiryWarningBtn: 'Verstanden',

  // Form placeholders
  existingImageOption: '-- vorhandenes Bild --',
  fiapSearchPlaceholder: 'Name oder FIAP-Nummer eingeben (mind. 2 Zeichen)...',
  fiapSearchMin: 'Mindestens 2 Zeichen eingeben...',
  fiapSearchLoading: 'Suche läuft...',
  fiapSearchNone: 'Keine Salons gefunden – Wettbewerbsliste noch nicht importiert?',
  salonSelected: '✅ Salonname und FIAP-Nummer wurden übernommen',
  validationMsg: 'Bitte Bild, Land, Salonname und FIAP Nummer angeben',

};

export default de;
